module.exports = __webpack_public_path__ + "img/rosemount-3051s-coplanar-pressure-transmitter-1-5-valve.2b1035e1.2b1035e1.png";